import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs';

@Component({
  selector: 'app-title',
  templateUrl: './title.html',
  styleUrl: './title.scss',
  standalone: true
})

export class Title implements OnInit  {

  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  title: string | undefined;

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let currentRoute = this.activatedRoute;
        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }
        this.title = currentRoute.snapshot.data['title'];
      });
    this.title = this.activatedRoute.snapshot.data['title'];
  }

}
